import { PROGRESS_STEP } from '@/features/InvoiceReport/Edit/components/UtilizePastDetails/constants';
import { useDataContext } from '@/features/InvoiceReport/Edit/components/UtilizePastDetails/context/UtilizePastDetailsDataContext';
import { useTranslation } from '@/i18n';
import { ButtonGroup, ButtonV2 } from '@moneyforward/ap-frontend-components';
import { FC } from 'react';

type Props = {
  onCancel: VoidFunction;
  disabled: boolean;
  isLoading: boolean;
};

export const Footer: FC<Props> = ({ onCancel, disabled, isLoading }) => {
  const { t } = useTranslation();
  const { onSetCurrentStep } = useDataContext();
  return (
    <ButtonGroup>
      <ButtonV2 size='md' color='primary' isSecondary onClick={onCancel}>
        {t('cancel')}
      </ButtonV2>
      <ButtonV2
        isDisabled={disabled}
        size='md'
        color='primary'
        isLoading={isLoading}
        onClick={() => onSetCurrentStep(PROGRESS_STEP.ON_SELECT_INVOICE)}
      >
        {t('selected')}
      </ButtonV2>
    </ButtonGroup>
  );
};
